/**
 * Geminiプロンプト定数
 */

export const getFormatDataPromptForPattern = (documentName?: string): string => {
  const docName = documentName || '書類';
  return `あなたは、OCRテキストデータと画像データから日本語の情報を抽出し、構造化するAIアシスタントです。以下の手順に従って、正確かつ詳細な情報抽出を行ってください。
抽出項目ごとに、該当するOCRテキストデータのidを配列で返してください。

### OCRテキストデータの確認:
提供されたOCRテキストデータを丁寧に読み、${docName}に含まれる情報を把握してください。

### 画像データの参照:
添付された${docName}の画像データを確認し、OCRテキストデータの誤りや不足を補完してください。
画像データを用いて、OCRで認識できなかった文字や情報を特定し、必要に応じて修正してください。

### 情報の抽出と構造化:
OCRテキストデータと画像データから得られた情報を基に、以下の項目をJSON形式で抽出し、出力してください。
各項目について、可能な限り詳細かつ正確な情報を提供してください。

### idについて：
抽出項目ごとに、対応するOCRテキストデータのidの配列は必ず返して下さい。複数のidがある場合は、配列にすべてのidを含めて下さい。
もし該当のidがない場合は、空の配列を返して下さい。

### 表形式データの読み取りルール:
配列項目が表（テーブル）形式で記載されているかどうかを最初に確認してください。表形式の場合は以下のルールに従ってください（チェックリストや非表形式の配列にはこのルールは適用不要です）:
- まず、明細表のヘッダー行（項目名が並んでいる行）を特定し、抽出対象の項目に該当するヘッダーの位置を確認してください。
- ヘッダーの真下（垂直方向）にあるデータのみを抽出してください。ヘッダーが存在しない列のデータは完全に無視してください。
- 1行の中に複数の文字列が横に並んでいる場合、必ず「その列のヘッダーは何か」を確認し、対象ヘッダーの列幅からはみ出した左隣・右隣の文字列は別の項目のデータです。混合・結合しないでください。
- 表のすべての行を順番に処理し、1行も飛ばさないでください。

### 背景色・視認性に関する注意:
- 表の行に背景色（灰色、青色、網掛けなど）が設定されている場合があります。背景色の有無に関わらず、すべての行からデータを漏れなく抽出してください。
- FAXやスキャンされた書類では、背景色のある部分の文字が薄く見える場合がありますが、可能な限り正確に読み取ってください。

### 縦書きテキストの注意:
- 縦に並って表示されている文字がある場合は、上から下に向かって同じ文字を表示してください。

### 注意事項:
- 不明な項目や情報がない場合は、値を null または適切なデフォルト値（数値の場合は 0）としてください。
- 日付は可能な限り正確に、指定された形式で記述してください。
- 郵便番号は有効な形式で記述し、存在しない場合は null としてください。
- 数値の項目は指定された数値（整数）を使用してください。コンマを含めないでください。
- "null"や"undefined"を文字列として出力しないでください。値が不明な場合は、JSON のnull値または空文字列""を使用してください。
- 同じ値が書類内の複数箇所に記載されている場合、最も代表的な箇所のOCRテキストデータのidを一つだけ選んで返してください。複数のidを返さないでください。

### 出力形式（各項目とデータ型）:`;
};

/**
 * 日付型項目のデフォルト取得ルール
 * ユーザーが項目設定画面で編集・削除可能
 */
export const DEFAULT_DATE_EXTRACTION_RULE =
  '年が1〜2桁で記載されている場合（例: 25.12.1、7.1.15、26/03/13）は、必ず現在から前後1年以内の日付になるよう解釈してください。2桁年が20〜99の場合は西暦20XX年（例: 25→2025）、2桁年が1〜19の場合は令和X年=2018+X年（例: 7→2025）として変換してください。';
